// The Comic Machine - Page UI

var PageController = (function() {

  // Handles UI and DOM manipulation
  var UI = {

    // DOM elements to manage
    elements: {
      container: null,
      list: null,
      pages: {
        list: null,
        add: null
      }
    },

    sortableList: null,

    // Initialize the UI and DOM manager
    initialize: function() {

      var container = document.querySelector(".timeline") || document;

      // Set base container
      UI.elements.container = container;
      UI.elements.pages.list = container.querySelector(".page-list");
      UI.elements.pages.add = container.querySelector(".page-add");

      // Bind handlers to events
      UI.bindEvents();

      // Update the UI
      UI.updateDOM();

      // Handle the sortable list of elements
      UI.sortableList = new Drag.Sortable(UI.elements.pages.list);

    },

    // Bind handlers to events
    bindEvents: function() {

      // Handle on click of add new page button
      attachHandler(UI.elements.pages.add, function(event, i) {
        // Add a page to the comic
        Page.addPage();
      });

      Events.global.on("tcm.page.update", UI.updateDOM);
      Events.global.on("tcm.comic.reset", UI.updateDOM);

    },

    // Update the UI and DOM elements with the current data
    updateDOM: function() {

      var list = UI.elements.pages.list;
      var html = "";

      // Return if the list element does not exist
      if (!list) {
        return list.innerHTML = html;
      }

      // Loop over comic pages to add to UI
      Page.pageList && Page.pageList.forEach(function(item, i) {
        item.name = i === 0 ? 'Cover' : 'Page ' + i;
        var classes = i === Page.pageIndex ? 'page-selected' : '';
        var thumbnail = item.thumbnail ? item.thumbnail.url : false;
        html += [
          '<li class="', classes, '">',
          '<div>',
          '<a href="#" class="page-thumb">',
          thumbnail ? '<img src="' + thumbnail + '">' : '',
          '<span>', item.name, '</span>',
          '</a>',
          '<a href="#" class="page-remove">x</a>',
          i === 0 ? '' :
          '<a href="#" class="page-insert page-insert-prev" data-page-index="' + i + '">+</a>',
          '<a href="#" class="page-insert page-insert-next" data-page-index="' + i + '">+</a>',
          '</div>',
          '</li>',
        ].join("");
      });

      // Append the list items to the list element
      list.innerHTML = html;

      // Set the width of the list element based on item count
      var listItem = list.querySelector("li");
      var listItemWidth = listItem ? listItem.offsetWidth : 0;
      var listWidth = Page.pageList ? listItemWidth * Page.pageList.length : 0;
      var listOffset = 125;
      list.style.width = (listWidth + listOffset) + "px";

      // Loop over elements to bind click event handler to remove page
      attachHandler(".page-remove", function(event, i) {
        // Remove the page from the comic
        Page.removePage(null, i);
      });

      // Loop over elements to bind click event handler to select page
      attachHandler(".page-thumb", function(event, i) {
        // Select the page
        Page.selectPage(null, i);
      });

      // Loop over elements to bind click event handler to insert page
      attachHandler(".page-insert", function(event, i) {
        var button = event.target;
        var previous = button.className.indexOf("page-insert-prev") > -1;
        var index = window.parseInt(button.getAttribute("data-page-index"));
        index += previous ? 0 : 1;
        // Insert the page into the comic
        Page.addPage(null, null, index);
      });

    },

  };

  // Wait for the comic to initialize before initializing the UI manager
  Events.global.on("tcm.initialized", UI.initialize);

  // Public / exposed object
  return UI;

})();
